<div class="overlay animated fadeIn" *ngIf="showError || loading"></div>

<div class="loginBodyContainer">
    <div class="LoginHeadderContainer">
      <p class="LoginERPTitle">{{ 'HOME.TITLE' | translate }}
        <i class="material-icons">cloud_queue</i>
      </p>
    </div>

    <div class="example-form" *ngIf="!showError" style="background: #fff;">
  
        <p class="LoginFormTitle">{{ 'ChangePassword' | translate }}</p>
    
        <mat-form-field style="width: 100%;margin-bottom: 5px;" appearance="outline">
            <mat-label>{{ 'NewPassword' | translate }}</mat-label>
            <input class="LogInTextBox" [disabled]="loading" matInput placeholder="{{ 'NewPassword' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="Password" required>
            <mat-icon style="cursor: pointer;" [disabled]="loading" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </mat-form-field>
      
        <mat-form-field style="width: 100%;margin-bottom: 5px;" appearance="outline">
          <mat-label>{{ 'RepeatNewPassword' | translate }}</mat-label>
          <input class="LogInTextBox" [disabled]="loading" matInput placeholder="{{ 'RepeatNewPassword' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="RepeatPassword" required>
          <mat-icon style="cursor: pointer;" [disabled]="loading" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>
    
            <button [disabled]="loading" mat-raised-button color="primary" class="loginButton" (click)="ChangeUserPassword();">
              <i class="material-icons ButtonCenterImage">cloud_queue</i>
              <span>{{ 'ChangePassword' | translate }}</span>
            </button>
           
            <p class="NoAccountDescription">{{'CopyRightRow' | translate}}</p>
    
          <mat-progress-bar mode="indeterminate" *ngIf="loading" class="loginIntermediateProgressBar"></mat-progress-bar>
    </div>

    </div>

